<script setup lang="ts">

import {route} from "ziggy-js";
import {useAvatar} from "@/composables/avatar";
import {computed, Ref, ref, watch} from "vue";
import NavigationActionItem from "@/layouts/components/NavigationActionItem.vue";
import {MenuItem, Project} from "@/types";
import LeftNavigationMenuItem from "@/layouts/components/LeftNavigationMenuItem.vue";
import {router} from "@inertiajs/vue3";
import axios from "axios";

interface Props {
    modelValue: boolean
    items: Array<MenuItem>
}
const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

watch(value, (value) => {
    if (value) {
        query()
    }
})

const projects: Ref<Array<Project>> = ref([]);

const query = () => {
    axios.get(route('web_api.projects.recent'))
        .then((response) => {
            projects.value = response.data
        })
        .catch(() => {
            projects.value = []
        })
}

const goToProject = (project: Project) => {
    router.visit(route('projects.show', {project: project.slug}), {
        onSuccess: () => {
            value.value = false
        }
    })
}
</script>

<template>
    <v-navigation-drawer
        v-model="value"
        app
        :temporary="true"
        location="start"
        scrim="grey"
        width="320"
        class="elevation-3 rounded-te-xl rounded-be-xl"
    >
        <v-list>
            <navigation-action-item v-model="value" />
            <left-navigation-menu-item
                v-for="(item, i) in items"
                :key="`item-${i}`"
                :value="item"
                @click="value = false"
            />
            <v-list-subheader class="text-caption font-weight-bold ml-3 pa-0">
                Projects
            </v-list-subheader>
            <v-list-item
                v-for="(item, i) in projects"
                :key="`project-${i}`"
                density="compact"
                class="mx-5 pl-2"
                rounded="lg"
                :slim="true"
                :link="true"
                @click="goToProject(item)"
            >
                <template #prepend>
                    <v-avatar
                        color="primary"
                        size="24"
                    >
                        <v-img
                            :src="useAvatar(item.name)"
                        />
                    </v-avatar>
                </template>
                <v-list-item-title class="text-body-2 font-weight-regular ml-1">
                    {{ item.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<style scoped>
.v-navigation-drawer__scrim {
    opacity: 0.1;
}
</style>
